<div class="table_footer container-fluid p-0 m-0" *ngIf="totalData() > 0">
  <div class="row align-items-center justify-content-between w-100 p-2 mt-1">
    <div class="col-2 d-flex justify-content-start align-items-center form-group m-0 p-2">
      <select class="form-select" [value]="pageSize()" (change)="onSelectChange($event)">
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="30">30</option>
        <option value="40">40</option>
        <option value="50">50</option>
      </select>
    </div>
    <div class="col-10 d-flex justify-content-end align-items-center">
      <div class="dataTables_info text-end">
        {{"action.show" | translate}} {{"action.of" | translate}} {{ calculateMin() }} {{"action.to" | translate}} {{ calculateMax() }}. {{"action.total" | translate}}:  {{totalData()}}
      </div>
    </div>
  </div>
  <div class="row w-100 p-0 m-0 mt-2">
    <div class="col-12 d-flex justify-content-center p-0">
      <div class="pagination_section d-flex justify-content-center">
        <ul class="pagination p-2 mb-0 flex-wrap">
          <li class="page-item" [class.disabled]="currentPage === 1">
            <a (click)="getMoreData('previous')" class="page-link" href="javascript:void(0);">
              {{"action.previous" | translate}}
            </a>
          </li>
          <li class="page-item" *ngIf="pageGroupStart > 1">
            <a class="page-link" href="javascript:void(0);" (click)="moveToPage(pageGroupStart - 1)">...</a>
          </li>
          <ng-container *ngFor="let page of pageNumberArray">
            <li class="page-item" [class.active]="page === currentPage">
              <a (click)="moveToPage(page)" class="page-link" href="javascript:void(0);">{{ page }}</a>
            </li>
          </ng-container>
          <li class="page-item" *ngIf="pageGroupStart + pagesPerGroup - 1 < totalPages">
            <a class="page-link" href="javascript:void(0);" (click)="moveToPage(pageGroupStart + pagesPerGroup)">...</a>
          </li>
          <li class="page-item" [class.disabled]="currentPage === totalPages">
            <a (click)="getMoreData('next')" class="page-link" href="javascript:void(0);">
              {{"action.next" | translate}}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
